var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowOutwardWhite2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_272_7686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_272_7686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3328 28.0003L23.6661 57.667C23.055 58.2781 22.2772 58.5837 21.3328 58.5837C20.3883 58.5837 19.6105 58.2781 18.9994 57.667C18.3883 57.0559 18.0828 56.2781 18.0828 55.3337C18.0828 54.3892 18.3883 53.6114 18.9994 53.0003L48.6661 23.3337H23.3328C22.3883 23.3337 21.5967 23.0142 20.9578 22.3753C20.3189 21.7364 19.9994 20.9448 19.9994 20.0003C19.9994 19.0559 20.3189 18.2642 20.9578 17.6253C21.5967 16.9864 22.3883 16.667 23.3328 16.667H56.6661C57.6105 16.667 58.4022 16.9864 59.0411 17.6253C59.68 18.2642 59.9994 19.0559 59.9994 20.0003V53.3337C59.9994 54.2781 59.68 55.0698 59.0411 55.7087C58.4022 56.3475 57.6105 56.667 56.6661 56.667C55.7216 56.667 54.93 56.3475 54.2911 55.7087C53.6522 55.0698 53.3328 54.2781 53.3328 53.3337V28.0003Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOutwardWhite2);
export default __webpack_public_path__ + "static/media/arrowOutwardWhite2.c774d79d06dffb072bd046d5eb4ddc36.svg";
export { ForwardRef as ReactComponent };